/**
 * Utilitaires pour le formatage des numéros de téléphone
 * 
 * Format de stockage : +33612345678 (international, sans espaces)
 * Format d'affichage : +33 6 12 34 56 78 (avec espaces pour lisibilité)
 */

/**
 * Formate un numéro de téléphone pour l'enregistrement (format international sans espaces)
 * Accepte : "0612345678", "06 12 34 56 78", "+33612345678", etc.
 * Retourne : "+33612345678"
 */
export function formatPhoneForStorage(value: string): string {
  if (!value) return '';
  
  // Nettoyer tous les caractères non numériques sauf le +
  let cleaned = value.replace(/[^\d+]/g, '');
  
  // Si vide, retourner vide
  if (!cleaned || cleaned === '+') return '';
  
  // Si commence par 0, remplacer par +33
  if (cleaned.startsWith('0')) {
    cleaned = '+33' + cleaned.substring(1);
  }
  // Si ne commence pas par +, ajouter +33
  else if (!cleaned.startsWith('+')) {
    cleaned = '+33' + cleaned;
  }
  
  // S'assurer qu'il n'y a pas d'espaces
  return cleaned.replace(/\s/g, '');
}

/**
 * Formate un numéro de téléphone pour l'affichage (format lisible avec espaces)
 * Accepte : "+33612345678"
 * Retourne : "+33 6 12 34 56 78"
 */
export function formatPhoneForDisplay(phone: string): string {
  if (!phone) return '';
  
  // Nettoyer d'abord pour avoir un format cohérent
  let cleaned = phone.replace(/[^\d+]/g, '');
  
  if (!cleaned) return '';
  
  // Si commence par 0, remplacer par +33
  if (cleaned.startsWith('0')) {
    cleaned = '+33' + cleaned.substring(1);
  }
  // Si ne commence pas par +, ajouter +33
  else if (!cleaned.startsWith('+')) {
    cleaned = '+33' + cleaned;
  }
  
  // Formater avec espaces pour les numéros français (+33)
  if (cleaned.startsWith('+33')) {
    const number = cleaned.substring(3); // Tout après +33
    if (number.length >= 9) {
      // Format : +33 X XX XX XX XX
      return '+33 ' + number.replace(/(\d{1})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5').trim();
    } else {
      // Si le numéro est incomplet, afficher tel quel avec le +33
      return '+33 ' + number;
    }
  }
  
  // Pour les autres formats internationaux, retourner tel quel
  return cleaned;
}

/**
 * Gère la saisie dans un champ téléphone
 * Permet la saisie libre (0612345678 ou 06 12 34 56 78)
 * Retourne la valeur telle quelle pour permettre la saisie naturelle
 * Le formatage final se fait au onBlur avec formatPhoneForStorage
 */
export function handlePhoneInputChange(value: string): string {
  // Permettre la saisie libre, on formatera au onBlur
  return value;
}




